<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()"  >
              <a class="anchor" id="blocEvolutionEffectif"></a>

    <v-card elevation="2" class="mb-1 flex-grow-1">
      <v-card-title><v-icon dense left color="indigo darken-2">person</v-icon>Évolution Effectif</v-card-title>

      <v-card-text><BarChart :data="evolutionEffectif" /></v-card-text>

    </v-card>
  </v-col>
</template>

<script>

import BarChart from "@/components/charts/barChart";

export default {
  name: "EvolutionEffectif",
  props: [],
  components: {
    BarChart,
  },
  data() {
    return {
    }
  },
  computed: {
    evolutionEffectif: function () {
      var effectif = this.$store.getters.getbloc("administratif", "donnees", "evolutionEffectif", null, "valeur")
      effectif.sort( function (a, b) {return a.annee - b.annee})
      var cleanedEffectif = []
      for (var idx in effectif) {
        if (effectif[idx]['effectif'] != null) {
          cleanedEffectif.push(effectif[idx])
        }
      }
      return cleanedEffectif;
    },
  },
  methods: {
     async copy(s) {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(this.ConvertToCSV(JSON.stringify(s)));
            alert('Copied!');
          }
    },
    condition() {
      return this.$store.getters.condition(
          "administratif",
          "donnees",
          "evolutionEffectif",
          "valeur"
      ) && this.evolutionEffectif.length > 1;
    },
    formatCurrency(value) {
      if (value) {
        return value.toLocaleString() + "€";
      } else {
        return "";
      }
    },
    formatPct(value) {
      if (value) {
        return (value*100).toFixed(2)+"%";
      } else {
        return "";
      }
    },
  },
};
</script>
